import { Environment, Network, Observable, RecordSource, Store } from 'relay-runtime';

const GATEWAY_URL = '/gateway/api/graphql';

function createRelayEnvironment() {
	const network = Network.create((params, variables) => {
		const response = fetch(GATEWAY_URL, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			credentials: 'include',
			body: JSON.stringify({ query: params.text, variables }),
		});
		return Observable.from(response.then((data) => data.json()));
	});
	const store = new Store(new RecordSource());
	return new Environment({ network, store });
}

export default createRelayEnvironment();
